import { getVideoEditionsEditListRefetchInterval } from '@app/modules/video-editions';
import { webApi } from '@mi-front/api-clients';

/**
 * Lists video editor edits for a composition; refetches on an interval only while a render job is pending.
 */
export function useCompositionVideoEditionsEditsQuery(compositionId: string) {
  return webApi.useGetCompositionsDetailEdits(compositionId, {
    query: {
      refetchInterval: (query) => getVideoEditionsEditListRefetchInterval(query.state.data),
    },
  });
}
